<template>
  <div style="height: 100%; pointer-events: auto">
    <div
      style="
        position: absolute;
        z-index: 9999;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      "
    >
      <iframe
        style="width: 100%; height: 100%"
        src="http://largescreen.cleverplanting.com/#/newCfWisdomCloud"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Plant',
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/product/Plant.vue